<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_3"><span class="bold">The Killings</span></a><a id="page_4"></a></h1><a id="page_4">
<p class="author"><span class="bold">Clark Howard</span></p>
<div class="img_container">
<img alt="Images" src="images/logo3.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?228605e2